import {
  AdminLayoutComponent,
  AuthLayoutComponent,
  HeaderComponent,
  LayoutComponent,
  MenuComponent,
  NotificationComponent,
  OptionsComponent,
  SidebarComponent
} from "./core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import { AgmCoreModule } from "@agm/core";
import { AppComponent } from "./app.component";
import { AppRoutes } from "./app.routing";
import { BidiModule } from "@angular/cdk/bidi";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MultilevelMenuService, NgMaterialMultilevelMenuModule } from "ng-material-multilevel-menu";
import { NgModule, LOCALE_ID } from "@angular/core";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { RouterModule } from "@angular/router";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ServServiceService } from './shared/dbcontroller/serv-request.service';
import { AMControllerService } from './shared/dbcontroller/dbcontroller.service';
import { ToastrModule } from 'ngx-toastr';
import { DecimalPipe, DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatInputModule } from '@angular/material/input';
import { QuillModule } from 'ngx-quill';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MenuService } from './core/menu/menu.service';
import { MatDividerModule } from '@angular/material/divider';
import { GtoolbarModule } from './shared/gtoolbar/gtoolbar.module';
import { TabContentComponent } from './core/admin-layout/tab-content.component';
import { ContentContainerDirective } from './core/admin-layout/content-container.directive';
import { TabService } from './core/admin-layout/tab.service';
import { PrintMainLayoutComponent } from "./core/print-main-layout/print-main-layout.component";
// import { HotTableModule } from '@handsontable/angular';
// import { CompileDirective } from './compile.directive';
import { MatChipsModule } from '@angular/material/chips';
import { ConfirmationDialogComponent } from "./shared/confirmation-dialog/confirmation-dialog.component";
import { AgGridModule } from "ag-grid-angular";
import {DragDropModule} from '@angular/cdk/drag-drop';
// import { GToolbarConfig } from './shared/gtoolbar/gtoolbarcompo/gtoolbarcompo.component';
// import { GtoolbarModule } from './gtoolbar/gtoolbar.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    NotificationComponent,
    OptionsComponent,
    MenuComponent,
    AdminLayoutComponent,
    ContentContainerDirective,
    TabContentComponent,
    LayoutComponent,
    AuthLayoutComponent,
    ConfirmationDialogComponent,
    PrintMainLayoutComponent
  ], exports: [RouterModule],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LoadingBarRouterModule,
    MatSidenavModule,
    MatCardModule,
    AgGridModule.withComponents([]),
    MatMenuModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatSortModule,
    MatListModule,
    MatDividerModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatProgressBarModule,
    FlexLayoutModule,
    BidiModule,
    AgmCoreModule.forRoot({
      apiKey: "YOUR_GOOGLE_API_KEY"
    }),
    PerfectScrollbarModule,
    NgMaterialMultilevelMenuModule,
    NgSelectModule,
    MatInputModule,
    GtoolbarModule,
    DragDropModule,
    QuillModule.forRoot(),
    ToastrModule.forRoot()
  ],
  providers: [
    // {
    //   // provide: PERFECT_SCROLLBAR_CONFIG,
    //   // useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    // }
    { provide: LOCALE_ID, useValue: "en-GB" }, MultilevelMenuService,
    AMControllerService, ServServiceService, DatePipe, DecimalPipe, MatDatepickerModule, MenuService, TabService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
